import { Card, CardProps } from '@radix-ui/themes'

export const PrintableCard = (props: Omit<CardProps, 'className'>) => (
  <div className="w-full max-w-full overflow-x-auto pb-2 print:overflow-visible print:pb-0">
    <div className="min-w-[800px] print:min-w-0">
      <Card className="printable-card" {...props} />
    </div>
  </div>
)
